import React from "react";
import { Box } from "@bca/ui-library";

const GradeRetailReadySVG: React.FunctionComponent = () => (
  <Box display="flex">
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="#152D6D"/>
      <path d="M8.39 7.047h3.712c.762 0 1.416.114 1.963.342.55.228.975.565 1.27 1.011.297.447.445.996.445 1.648 0 .533-.09.991-.273 1.374-.178.378-.43.695-.759.95-.323.25-.704.451-1.142.602l-.649.341H9.73l-.013-1.6h2.4c.36 0 .658-.063.895-.19.237-.128.414-.306.533-.534.123-.228.184-.492.184-.793 0-.319-.059-.594-.177-.827a1.2 1.2 0 0 0-.54-.533c-.242-.123-.545-.185-.91-.185h-1.66V17H8.39V7.047ZM13.956 17l-2.27-4.437 2.167-.013 2.297 4.354V17h-2.194Z" fill="#fff"/>
    </svg>
  </Box>
);

export default GradeRetailReadySVG;
